import { signOut } from 'aws-amplify/auth';
import { Header } from 'nhsuk-react-components';
import FeedBack from 'components/FeedBack';
import useFetchUser from 'queries/fetch/fetchUser.ts';
import useUser from 'hooks/useUser.ts';
import MessagesUnreadFilledIcon from 'components/icons/MessagesUnreadFilledIcon.tsx';
import MessagesIcon from 'components/icons/MessagesIcon.tsx';
import useNotifications from 'queries/fetch/useNotifications.ts';
import { getTeamsForAdmin } from 'utils/adminUtils.ts';
import featureFlags from 'services/featureFlags.ts';
import { LINK_NHS_NOTIFY, LINK_SPI_GUIDANCE } from 'constants/links';

function HomeHeader() {
  const { data } = useFetchUser();
  const user = useUser();
  const { data: notifications } = useNotifications();
  const unreadCount = notifications?.filter((notification) => !notification.read).length ?? 0;
  const adminTeamIds = getTeamsForAdmin(user.roles);
  const hasAdminPanel = adminTeamIds.length > 0;

  return (
    <>
      <Header
        role="banner"
        id="maincontent"
        data-testid="home-header"
        service={{ text: 'Select People for Invitation', href: '/' }}
        className="home-header-container"
      >
        {user?.userId && (
          <Header.Account>
              {
                  featureFlags.notificationsEnabled && (
                  <Header.AccountItem
                    href="/activity"
                    aria-label={unreadCount > 0
                      ? `Notifications, you have ${unreadCount} new notification${unreadCount === 1 ? '' : 's'}`
                      : 'Notifications'}
                  >
                    {
                        unreadCount > 0
                          ? <MessagesUnreadFilledIcon />
                          : <MessagesIcon />
                    }
                  </Header.AccountItem>
                  )
              }
            <Header.AccountItem
              icon
            >
              {user.displayName}
              {data?.roleName ? ` (${data.roleName})` : ''}
            </Header.AccountItem>
              {
                  hasAdminPanel && (
                  <Header.AccountItem href="/admin">
                    Admin panel
                  </Header.AccountItem>
                  )
              }
            <Header.AccountItem onClick={() => signOut()} href="#">
              Log out
            </Header.AccountItem>
          </Header.Account>
        )}
        <Header.Navigation>
          <Header.NavigationItem href="/campaigns">
            Manage Campaigns
          </Header.NavigationItem>
          <Header.NavigationItem
            href={LINK_SPI_GUIDANCE}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Guidance in new tab"
          >
            Guidance
          </Header.NavigationItem>
          <Header.NavigationItem
            href={LINK_NHS_NOTIFY}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open NHS Notify in new tab"
          >
            NHS Notify
          </Header.NavigationItem>
        </Header.Navigation>
      </Header>
      {user.displayName && <FeedBack />}
    </>
  );
}

export default HomeHeader;
